import AppFooter from "@/components/app-footer";
import GoToTop from "@/components/go-to-top";
import InfoGraphicCurrentProfit from "@/components/info-graphic-current-profit";
import InfoGraphicOperatingProfit from "@/components/info-graphic-operating-profit";
import InfoGraphicRoeRoa from "@/components/info-graphic-roe-roa";
import InfoGraphicSales from "@/components/info-graphic-sales";
import Top from "@/components/top";
import TopExperienceItem from "@/components/top-experience-item";
import AppHeader from "./app-header";
import Feature from "./feature";
var App = /** @class */ (function () {
    function App(el) {
        console.log("[create] App");
        this._el = el;
    }
    App.prototype.setup = function () {
        console.log("[call] App.setup");
        Array.prototype.forEach.call(this._el.querySelectorAll(".app-header"), function (el) {
            new AppHeader(el).setup();
        });
        Array.prototype.forEach.call(this._el.querySelectorAll(".app-footer"), function (el) {
            new AppFooter(el).setup();
        });
        Array.prototype.forEach.call(this._el.querySelectorAll(".go-to-top"), function (el) {
            new GoToTop(el).setup();
        });
        Array.prototype.forEach.call(this._el.querySelectorAll(".infographic.top-financial-data--sales"), function (el) {
            new InfoGraphicSales(el).setup();
        });
        Array.prototype.forEach.call(this._el.querySelectorAll(".infographic.top-financial-data--operating-profit"), function (el) {
            new InfoGraphicOperatingProfit(el).setup();
        });
        Array.prototype.forEach.call(this._el.querySelectorAll(".infographic.top-financial-data--current-profit"), function (el) {
            new InfoGraphicCurrentProfit(el).setup();
        });
        Array.prototype.forEach.call(this._el.querySelectorAll(".infographic.top-financial-data--roe-roa"), function (el) {
            new InfoGraphicRoeRoa(el).setup();
        });
        Array.prototype.forEach.call(this._el.querySelectorAll(".top-experience.is-large .top-experience__item"), function (el, index) {
            new TopExperienceItem(el).setup();
        });
        Array.prototype.forEach.call(this._el.querySelectorAll(".page--top"), function () {
            new Top().setup();
        });
        Array.prototype.forEach.call(this._el.querySelectorAll(".page--feature"), function () {
            new Feature().setup();
        });
    };
    App.prototype.teardown = function () {
        console.log("[call] App.teardown");
    };
    return App;
}());
export default App;
